<template>
  <div v-if="custodyExpenses" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("CustodyExpenses.employeeName") }}</th>
            <th>{{ $t("CustodyExpenses.name") }}</th>
            <th>{{ $t("CustodyExpenses.description") }}</th>
            <th>{{ $t("notes") }}</th>
            <th>{{ $t("info") }}</th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              {{ $t("edit") }}
            </th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              {{ $t("delete") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(CustodyExpense, index) in custodyExpenses" :key="index">
            <td>{{ ++index + pagination.currentIndex }}</td>
            <td>
              {{ isDataExist(CustodyExpense.employeeNameCurrent) }}
            </td>
            <td>
              {{ isDataExist(CustodyExpense.custodyExpenseNameCurrent) }}
            </td>
            <td>
              {{ isDataExist(CustodyExpense.custodyExpenseDescriptionCurrent) }}
            </td>
            <td>
              {{ isDataExist(CustodyExpense.custodyExpenseNotes) }}
            </td>
            <td>
              <button
                v-b-modal.CustodyExpenseInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setCustodyExpense(CustodyExpense)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              <router-link
                :to="{
                  name: 'CustodyExpenseEdit',
                  params: {
                    custodyExpenseToken: CustodyExpense.custodyExpenseToken,
                  },
                }"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              <button
                v-b-modal.CustodyExpenseDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setCustodyExpense(CustodyExpense)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import privilegeMixin from "@/utils/privilege-mixin";
import { setDataMultiLang, timeToLang, isDataExist } from "@/utils/functions";

export default {
  mixins: [privilegeMixin],
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
    };
  },
  props: ["custodyExpenses", "pagination"],
  methods: {
    setCustodyExpense(data) {
      this.$emit("setCustodyExpense", data);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn, dataUnd) {
      return setDataMultiLang(lang, dataAr, dataEn, dataUnd);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
  async created() {},
};
</script>
